import { Effect } from "../../Materials/effect";
var name = 'logDepthDeclaration';
var shader = "#ifdef LOGARITHMICDEPTH\nuniform float logarithmicDepthConstant;\nvarying float vFragmentDepth;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var logDepthDeclaration = { name: name, shader: shader };
//# sourceMappingURL=logDepthDeclaration.js.map